var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.toggleAllowed
    ? _c(
        "el-collapse",
        {
          staticClass: "flex-column mb-9",
          attrs: { id: "form-field-" + _vm.field },
          model: {
            value: _vm.activeField,
            callback: function($$v) {
              _vm.activeField = $$v
            },
            expression: "activeField"
          }
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { name: _vm.field, active: "" } },
            [
              _c(
                "template",
                { slot: "title" },
                [
                  _c(
                    "icon-svg",
                    {
                      attrs: {
                        "icon-name": _vm.field,
                        width: 24,
                        height: 24,
                        viewBox: "0 0 32 32"
                      }
                    },
                    [_c("icon-" + _vm.field, { tag: "component" })],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "strong",
                    { staticClass: "ml-3 fs-4 self-center lh-20 " },
                    [_vm._v(_vm._s(_vm.title))]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "px-6" }, [_vm._t("default")], 2)
            ],
            2
          )
        ],
        1
      )
    : _c(
        "div",
        {
          staticClass: "flex-column mb-9",
          attrs: { id: "form-field-" + _vm.field }
        },
        [
          _c(
            "div",
            { staticClass: "lh-24 flex-row bb-1-gray-05 pb-2 ai-center" },
            [
              _c(
                "icon-svg",
                {
                  attrs: {
                    "icon-name": _vm.field,
                    width: 24,
                    height: 24,
                    viewBox: "0 0 32 32"
                  }
                },
                [_c("icon-" + _vm.field, { tag: "component" })],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "flex-row jc-space wp-10 ml-3" }, [
                _c("strong", { staticClass: "fs-4 self-center" }, [
                  _vm._v(_vm._s(_vm.title))
                ]),
                _vm._v(" "),
                _vm.switchAllowed
                  ? _c(
                      "h6",
                      {
                        staticClass:
                          "cpointer semibold form-fields-wrapper--switch link fs-3 lh-20 m-0",
                        attrs: {
                          "data-bot":
                            "opp-overview__company--link-switch-" + _vm.field
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("switch-form-field")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.switchLabel))]
                    )
                  : _vm._e()
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "px-6" }, [_vm._t("default")], 2)
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }